import React, { useEffect } from 'react';
import { MessagePlugin, Table } from 'tdesign-react';
import styled from 'styled-components';
import { useMemoizedFn } from 'ahooks';
import { useSearchParams } from 'react-router-dom';
import useTable from '@/hooks/useTable';
import { renderByte, renderDateTime } from '@/utils/common';
import { getLogFileList } from '@/services/clusterService';
import Detail from './Detail';

export default function Logs({ host, type }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');

  const columns = [
    {
      colKey: 'logDispayName',
      title: '文件名',
      cell: ({ row }) => <Detail host={host} clusterName={clusterName} detail={row} />,
      sorter: true,
    },
    {
      colKey: 'size',
      title: '文件大小',
      cell: renderByte,
      width: 200,
      sorter: true,
    },
    {
      colKey: 'modifyTime',
      title: '最后更新时间',
      width: 200,
      sorter: true,
      cell: renderDateTime,
    },
  ];

  const onSearch = useMemoizedFn(async (params) => {
    const {
      data: { logInfos, error },
    } = await getLogFileList({
      ...params,
      clusterName,
      host,
      type,
    });
    if (error) {
      MessagePlugin.error(error);
      return;
    }
    setData(logInfos || []);
  });

  const { config, header, doSearch, setData } = useTable({
    columns,
    onSearch,
    columnController: null,
  });

  useEffect(() => {
    doSearch();
  }, [doSearch]);

  return (
    <Root>
      {header}
      <Table {...config} />
    </Root>
  );
}

const Root = styled.div`
  padding-top: 16px;
`;
